import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const VmMaintenance = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='VmMaintenance' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M19,9.9999 L19,1.9999 L7,1.9999 L7,13.9999 L14,13.9999 L14,6.9999 L2,6.9999 L2,18.9999 L10,18.9999 M14,23 L20,17 M21,14 C19.8954305,14 19,14.8954305 19,16 C19,17.1045695 19.8954305,18 21,18 C22.1045695,18 23,17.1045695 23,16' />
  </StyledIcon>
);
